<template lang="pug">
	content-page
		div(slot="nav")
			nav
				.subtitle-1  {{$t('page.videos.navigation:heading')}}
				ul.list-unstyled
					li
						nuxt-link(:to="localePath({name:'videos'})" :title="$t('page.videos.navigation:last.published')") {{$t('page.videos.navigation:last.published')}}
					li
						nuxt-link(:to="localePath({name:'videos-snowshow'})" :title="$t('page.videos.navigation:snow.show')") {{$t('page.videos.navigation:snow.show')}}
					li
						nuxt-link(:to="localePath({name:'videos-tipstricks'})" :title="$t('page.videos.navigation:tips.tricks')") {{$t('page.videos.navigation:tips.tricks')}}
				.subtitle-1 {{$t('page.videos.navigation:video.per.country')}}
				ul.list-unstyled
					li
						nuxt-link(:to="localePath({name:'videos-country', params: {country:'oostenrijk'}})" :title="$t('page.videos.navigation:austria.link.title')")
							img.flag(src='https://static.wintersport.nl/images/flags/svg/at.svg' :alt="$t('page.videos.navigation:austria')" width="16")
							|  {{$t('page.videos.navigation:austria')}}
							|
							small.grey--text ({{totalVideos('at')}})
					li
						nuxt-link(:to="localePath({name:'videos-country', params: {country:'italie'}})" :title="$t('page.videos.navigation:italy.link.title')")
							img.flag(src='https://static.wintersport.nl/images/flags/svg/it.svg' :alt="$t('page.videos.navigation:italy')" width="16")
							|  {{$t('page.videos.navigation:italy')}}
							|
							small.grey--text ({{totalVideos('it')}})
					li
						nuxt-link(:to="localePath({name:'videos-country', params: {country:'frankrijk'}})" :title="$t('page.videos.navigation:france.link.title')")
							img.flag(src='https://static.wintersport.nl/images/flags/svg/fr.svg' :alt="$t('page.videos.navigation:france')" width="16")
							|  {{$t('page.videos.navigation:france')}}
							|
							small.grey--text ({{totalVideos('fr')}})
					li
						nuxt-link(:to="localePath({name:'videos-country', params: {country:'zwitserland'}})" :title="$t('page.videos.navigation:switzerland.link.title')")
							img.flag(src='https://static.wintersport.nl/images/flags/svg/ch.svg' :alt="$t('page.videos.navigation:switzerland')" width="16")
							|  {{$t('page.videos.navigation:switzerland')}}
							|
							small.grey--text ({{totalVideos('ch')}})

				template(v-if="showTipsTricksMenu")
					.subtitle-1 {{$t('page.videos.navigation:skitips')}}
					ul.list-unstyled
						li(v-for="tip in tipsByType('ski')" :key="tip.id")
							nuxt-link(:to="localePath({name: 'videos-tipstricks-slug', params: { slug: tip.slug }})" :title="tip.title") {{tip.title}}
					.subtitle-1 {{$t('page.videos.navigation:snowboardtips')}}
					ul.list-unstyled
						li(v-for="tip in tipsByType('snowboard')" :key="tip.id")
							nuxt-link(:to="localePath({name: 'videos-tipstricks-slug', params: { slug: tip.slug }})" :title="tip.title") {{tip.title}}

		div.hidden-sm-and-down(slot="sidebar")
			.infosheet
				ad.mb-6
				offers

		div
			nuxt-child
</template>

<script>
import gql from 'graphql-tag';

const query = gql`
	query getVideosMenu($countryCodes: [String]) {
		countries: countriesByCountryCodes(countryCodes: $countryCodes) {
			countryCode
			videos {
				id
			}
		}
		tipstricks {
			title
			slug
			type
		}
	}
`;

export default {
	name: 'Videos',
	asyncData({ _params, app }) {
		app.ads({ sidebar: { visible: true } });

		return app.$graphClient
			.query({
				query,
				variables: {
					countryCodes: ['at', 'fr', 'it', 'ch']
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'videos-01', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		showTipsTricksMenu() {
			if (this.$route.name.split('__').length) {
				return this.$route.name.split('__')['0'] === 'videos-tipstricks-slug';
			}
			return false;
		}
	},
	methods: {
		tipsByType(type) {
			return this.tipstricks.filter(tip => tip.type === type);
		},
		totalVideos(countryCode) {
			return this.countries.find(country => country.countryCode === countryCode)
				.videos.length;
		}
	}
};
</script>
